import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { tokens } from '../../../../tokens';
import { SectionGap, type SectionStretch } from '../../../../types';

import { layoutTransition, LayoutVariant, layoutVariants } from './Layout.motion';

interface SectionWrapperProps {
    $gap?: SectionGap;
    $stretch?: SectionStretch;
    $alignEnd?: boolean;
}

export const LayoutWrapper = styled(motion.div).attrs({
    variants: layoutVariants,
    initial: LayoutVariant.Hidden,
    animate: LayoutVariant.Show,
    exit: LayoutVariant.Hidden,
    transition: layoutTransition,
})`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

// TODO: `$alignEnd` currently does not work correctly in Safari.
export const SectionWrapper = styled.div<SectionWrapperProps>`
    display: grid;
    justify-items: center;
    gap: ${tokens.section.gap[SectionGap.Small]}px;
    width: 100%;
    max-width: ${({ $stretch }) => $stretch && `${tokens.section.maxWidth[$stretch]}px`};
    margin-left: auto;
    margin-right: auto;

    &:not(:first-child) {
        margin-top: ${({ $gap }) => `${tokens.section.gap[$gap ?? SectionGap.Base]}px`};
    }

    ${({ $alignEnd }) =>
        $alignEnd &&
        css`
            flex: 1 1 auto;
            align-content: end;
            align-items: end;
        `};
`;
